import { CSSObject } from '@mui/material/styles';

/**
 * Helper to safely spread typography variants in styled components
 * This is needed because custom typography variants may not be recognized by TypeScript
 */
export function spreadTypography(typography: unknown): CSSObject {
  return typography as CSSObject;
}
